module.exports = __webpack_public_path__ + "static/Carnaval-ce3afd5faf43db86d2ecfb861049c3a7.jpg";